import { useState } from 'react';

// @TODO: lint rule
// eslint-disable-next-line boundaries/element-types
import { InputContainer } from '@_widgets/user';
import { RightChevronIcon } from '@_shared/icons';
import { Button } from '@_shared/ui/Button';
import { Typography } from '@_shared/ui/Typography';
import * as S from './AgeNGenderSlide.style';

export function AgeNGenderSlide({
	onNext,
	setAgnNGender,
	nickname,
}: {
	onNext: () => void;
	setAgnNGender: (birthYear: number, gender: '남자' | '여자') => void;
	nickname: string;
}) {
	const currentDate = new Date();

	const [gender, setGender] = useState<'남자' | '여자'>();
	const [birthYear, setBirthYear] = useState<number>(currentDate.getFullYear());

	return (
		<S.SlideContainer>
			<S.TermsSlide>
				<Typography type="headline-small" color="font-primary">
					{nickname}
					님의
					<br />
					성별과 나이를 알려주세요!
				</Typography>

				<InputContainer.Container>
					<Typography type="title-small" color="font-tertiary">
						성별
					</Typography>

					<S.GenderContainer>
						<S.Gender
							isActive={gender === '남자'}
							onClick={() => {
								setGender('남자');
							}}
						>
							<Typography
								type="title-large"
								color={gender === '남자' ? 'font-secondary' : 'font-tertiary'}
							>
								남자
							</Typography>
						</S.Gender>
						<S.Gender
							isActive={gender === '여자'}
							onClick={() => {
								setGender('여자');
							}}
						>
							<Typography
								type="title-large"
								color={gender === '여자' ? 'font-secondary' : 'font-tertiary'}
							>
								여자
							</Typography>
						</S.Gender>
					</S.GenderContainer>
				</InputContainer.Container>

				<InputContainer.Container>
					<Typography type="title-small" color="font-tertiary">
						태어난 연도
					</Typography>
					<InputContainer.Input
						type="number"
						maxLength={4}
						placeholder="태어난 연도를 입력해주세요. (ex. 1998)"
						onInput={(e) => {
							if (e.currentTarget.value.length > 4) {
								e.currentTarget.value = '9999';
							}

							setBirthYear(Number(e.currentTarget.value));
						}}
					/>
				</InputContainer.Container>
			</S.TermsSlide>

			<S.BottomButtonContainer>
				<Button
					bgColor={gender ? 'orange-primary' : 'warmgray-300'}
					fullWidth
					disabled={!gender}
					onClick={() => {
						setAgnNGender(birthYear, gender as '남자' | '여자');
						onNext();
					}}
				>
					<Typography type="title-large" color="white-primary">
						다음
					</Typography>
				</Button>
				<S.SkipText
					onClick={() => {
						onNext();
					}}
				>
					<Typography type="label-large">건너뛰기</Typography>
					<RightChevronIcon />
				</S.SkipText>
			</S.BottomButtonContainer>
		</S.SlideContainer>
	);
}
